import { createLogic } from 'redux-logic'
import { PAGINATION } from 'constants/common'
import StorageTypes from '../actionTypes/storage'
import SystemConfigTypes from '../actionTypes/systemConfig'
import UserTypes from '../actionTypes/user'
import { userAPI } from '../api'

const reloadUserInfo = createLogic({
  type: StorageTypes.RELOAD_USER_INFO_LOCAL_STORAGE_REQUEST,
  latest: true,

  // eslint-disable-next-line no-unused-vars
  async process({ action }, dispatch, done) {
    try {
      const res = await userAPI.fetchProfile()
      const user = res?.data?.user

      if (user?.id) {
        dispatch({
          type: UserTypes.MY_PROFILE_SUCCESS,
          payload: user
        })
      }
    } catch (error) {
      // do nothing
    }

    done()
  }
})

const loadLocalData = createLogic({
  type: StorageTypes.LOAD_LOCAL_STORAGE_REQUEST,
  latest: true,

  async process({ action = {} }, dispatch, done) {
    const { onSuccess, onError } = action.meta || {}

    try {
      const res = await userAPI.fetchProfile()
      const user = res?.data?.user
      if (user?.id) {
        dispatch({
          type: SystemConfigTypes.GET_MODULES_REQUEST
        })
        dispatch({
          type: UserTypes.MY_PROFILE_SUCCESS,
          payload: user
        })

        dispatch({
          type: SystemConfigTypes.GET_SYSTEM_CONFIG_LIST_REQUEST,
          payload: { limit: PAGINATION.unlimited }
        })

        if (onSuccess) {
          onSuccess()
        }
      } else {
        dispatch({
          type: UserTypes.MY_PROFILE_FAILURE,
          payload: {}
        })
      }
    } catch (error) {
      if (onError) {
        onError()
      }
    }

    done()
  }
})

export default [loadLocalData, reloadUserInfo]
